import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/tables/data/authorsTableData";
import axios from "axios";
import { useState } from "react";
import { json } from "react-router-dom";
import { useEffect, useCallback } from "react";
import DefaultNavbarMobile from "examples/Navbars/DefaultNavbar/DefaultNavbarMobile";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import { Box } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Loading from "components/Loading";
import appBar from "assets/theme/components/appBar";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import { blue } from "@mui/material/colors";
import apiClient from "Api";
import { useAuth } from "hooks/useAuth";
import { serialize } from "stylis";

function Sales() {
  let tableHeaders = [
    {
      Header: "Shopify Payment Id",
      accessor: "shopifyPaymentId",
      align: "left",
    },
    { Header: "E-mail ou Telefone", accessor: "email", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Valor", accessor: "amount", align: "center" },
    { Header: "Data", accessor: "data", align: "center" },
    { Header: "Método", accessor: "tipo", align: "center" },
  ];

  const { user } = useAuth();

  if (user.data.userRoles.includes("Ikigai")) {
    tableHeaders.push({
      Header: "Tenant",
      accessor: "Tenant",
      align: "center",
    });
  }

  const [columns, setColumns] = useState(tableHeaders);

  const [rows, setRows] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [isLoading, setIsLoading] = useState(false);
  const [timeRange, setTimeRange] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [tableData, setTableData] = useState({
    columns: columns,
    rows: rows,
    pageCount: pageCount,
    pageIndex: pageIndex,
    pageSize: 25,
    pageChangeHandle: handlePageChange,
    search: "",
    timeRange: timeRange,
  });

  function handlePageChange(pageIndexNew, pageSizeNew, search, timeNew) {
    const fetchData = async () => {
      let newPageIndex = pageIndexNew != null ? pageIndexNew : pageIndex;
      let newPageSize = pageSizeNew != null ? pageSizeNew : pageSize;
      let newTimeRange = timeNew != null ? timeNew : timeRange;

      search = search ? search : "";

      setIsLoading(true);

      let dateRange = "";

      if (newTimeRange != null) {
        dateRange = `&DateFilter=${newTimeRange}`;
      }

      apiClient
        .get(
          `/sales?PageIndex=${newPageIndex}&PageSize=${newPageSize}&ShopifyId=${search}&Email=${search}&Telefone=${search}&Tenant=${search}${dateRange}`
        )
        .then((reponseSales) => {
          setPageIndex(newPageIndex);
          setPageSize(newPageSize);
          setTimeRange(newTimeRange);

          let rowsPage = [];
          reponseSales.data.value.map((item) => {
            let urlSale = `/sales/${item.id}`;
            let urlTenant = `/stores/${item.tenantId}`;

            rowsPage.push({
              shopifyPaymentId: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="button"
                  color="text"
                  fontWeight="medium"
                  key={item.id}
                >
                  {item.shopifyPaymentId}
                </MDTypography>
              ),
              email: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="button"
                  color="text"
                  fontWeight="medium"
                >
                  {item.customerEmail ?? item.customerPhoneNumber}
                </MDTypography>
              ),
              status: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {item.cieloData.status == undefined &&
                    item.status != "SESSION_CREATED" && (
                      <Chip label="Erro" color="error" variant="outlined" />
                    )}
                  {item.cieloData.status == undefined &&
                    item.status == "SESSION_CREATED" && (
                      <Chip
                        label="Sessão de pagamento criada"
                        color="info"
                        variant="outlined"
                      />
                    )}
                  {item.cieloData.status == "Pending" && (
                    <Chip label="Pendente" color="warning" variant="outlined" />
                  )}
                  {item.cieloData.status == "Authorized" && (
                    <Chip label="Autorizado" color="info" variant="outlined" />
                  )}
                  {item.cieloData.status == "Denied" && (
                    <Chip label="Negado" color="error" variant="outlined" />
                  )}
                  {item.cieloData.status == "NotFinished" && item.appType == "CreditCard" && (
                    <Chip
                      label={item.cieloData?.creditCard?.reasonMessage}
                      color="error"
                      variant="outlined"
                    />
                  )}
                  {item.cieloData.status == "NotFinished" && item.appType != "CreditCard" && (
                    <Chip
                      label="Falha no processamento"
                      color="error"
                      variant="outlined"
                    />
                  )}
                  {item.cieloData.status == "PaymentConfirmed" && (
                    <Chip label="Pago" color="success" variant="outlined" />
                  )}
                  {item.cieloData.status == "Voided" && (
                    <Chip label="Cancelado" color="info" variant="outlined" />
                  )}
                  {item.cieloData.status == "Refunded" && (
                    <Chip label="Estornado" color="info" variant="outlined" />
                  )}
                  {item.cieloData.status == "Aborted" && (
                    <Chip
                      label="Cancelado por falha"
                      color="warning"
                      variant="outlined"
                    />
                  )}
                  {item.cieloData.status == "Scheduled" && (
                    <Chip
                      label="Recorrência agendada"
                      color="info"
                      variant="outlined"
                    />
                  )}
                </MDTypography>
              ),
              amount: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="caption"
                  color="text"
                  fontWeight="medium"
                >
                  {item.amount.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </MDTypography>
              ),
              data: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="button"
                  color="text"
                  fontWeight="medium"
                >
                  {new Date(item.createdAt).toLocaleString()}
                </MDTypography>
              ),
              tipo: (
                <MDTypography
                  component="a"
                  href={urlSale}
                  variant="button"
                  color="text"
                  fontWeight="medium"
                >
                  {item.appType == "Boleto" && (
                    <Chip
                      sx={{ width: "10rem" }}
                      label={
                        <>
                          <Icon sx={{ fontSize: "large" }}>receipt</Icon> Boleto
                        </>
                      }
                      variant="outlined"
                    />
                  )}
                  {item.appType == "Pix" && (
                    <Chip
                      sx={{ width: "10rem" }}
                      label={
                        <>
                          <Icon sx={{ fontSize: "large" }}>pix</Icon> Pix
                        </>
                      }
                      variant="outlined"
                    ></Chip>
                  )}
                  {(item.appType == "CreditCard" || item.appType == "CustomCreditCard" || item.appType == "ProtectedCard") && (
                    <Chip
                      sx={{ width: "10rem" }}
                      label={
                        <>
                          <Icon sx={{ fontSize: "large" }}>credit_card</Icon>{" "}
                          Cartão de crédito
                        </>
                      }
                      variant="outlined"
                    />
                  )}
                  {(item.appType == "EWallet") && (
                    <Chip
                      sx={{ width: "10rem" }}
                      label={
                        <>
                          <Icon sx={{ fontSize: "large" }}>credit_card</Icon>{" "}
                          EWallet
                        </>
                      }
                      variant="outlined"
                    />
                  )}
                </MDTypography>
              ),
              Tenant: (
                <MDTypography
                  component="a"
                  href={urlTenant}
                  variant="button"
                  color="text"
                  fontWeight="medium"
                  key={item.tenantId}
                >
                  {item.tenantShopifyShopDomain.replace(".myshopify.com", "")}
                </MDTypography>
              ),
            });
          });

          setRows(rowsPage);

          setTableData({
            columns: columns,
            rows: rowsPage,
            pageCount: reponseSales.data.totalItems,
            pageIndex: newPageIndex,
            pageSize: newPageSize,
            pageChangeHandle: handlePageChange,
            search: search,
            timeRange: newTimeRange,
          });
          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
        });
    };

    fetchData();
  }

  useEffect(() => {
    handlePageChange(pageIndex, pageSize, "", timeRange);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={4}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1.5}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Vendas
                </MDTypography>
              </MDBox>
              <MDBox pt={2}>
                <Loading isLoading={isLoading}></Loading>
                <DataTable
                  table={tableData}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  canSearch={true}
                  noEndBorder
                  searchPlaceHolder="Shopify payment id, email ou telefone"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Sales;
